import { createRouter, createWebHistory } from 'vue-router'
import ComponentCard from './components/ComponentCard.vue'

const routes = [
  {
    path: '/',
    name: 'ComponentCard',
    component: ComponentCard,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
